import { render } from "./ModalRequest.vue?vue&type=template&id=fe4b9f4c&scoped=true"
import script from "./ModalRequest.vue?vue&type=script&lang=js"
export * from "./ModalRequest.vue?vue&type=script&lang=js"

import "./ModalRequest.vue?vue&type=style&index=0&id=fe4b9f4c&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4b9f4c"]])

export default __exports__